import { getProductData } from "api";
import axios from "axios";
import { getProboAmount } from "utils/probo";

const price = (store) => {
  store.on("@init", () => ({ price: null, priceLoading: false }));
  store.on("price/set", (_, price) => {
    return { price };
  });

  let cancelPriceFetch;
  store.on(
    "price/fetch",
    async ({ product, canvas, proboCodes, productOptions }, customParams) => {
      const { dispatch } = store;
      cancelPriceFetch?.();
      const params = {
        product: product?.id,
        width: canvas.cutW / 1000,
        height: canvas.cutH / 1000,
        quantity: product?.proboProduct ? getProboAmount(productOptions) : 1,
        cutRadius: canvas.cutRadius,
        bgColor: canvas.bgColor,
        proboProductOptions: proboCodes,
      };

      const mergedPamarms = { ...params, ...customParams };
      if (!mergedPamarms.product) {
        return;
      }
      dispatch("price/setLoading", true);
      try {
        const [priceRequest, cancelRequest] = getProductData(mergedPamarms);
        cancelPriceFetch = cancelRequest;
        const price = await priceRequest;
        dispatch("price/set", price);
        dispatch("price/setLoading", false);
      } catch (err) {
        if (!axios.isCancel(err)) {
          if (err.response) {
            const { status, data } = err.response;
            store.dispatch(
              "notification/error",
              `Can't get price - ${status}, ${data}`
            );
          } else {
            store.dispatch(
              "notification/error",
              `Can't get price - ${err.message}`
            );
          }
          dispatch("price/setLoading", false);
        }
      }
    }
  );

  store.on("price/setLoading", (_, state) => {
    return { priceLoading: state };
  });
};

export default price;
